import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { MechanicalPermit } from 'types/Documents';

export const useMechanicalPermit = (id: string | null) =>
  useDocumentDetails<Document<MechanicalPermit> | null>(id);
